import { ILogger } from './logger.interface';
import { LogOptions } from './logger.types';

export class Logger implements ILogger {
  /**
   * Логирует сообщение об ошибке типа "error"
   *
   * @param message - Сообщение об ошибке.
   * @param options - Опции, определяют что будет залогировано.
   */
  error(message: unknown, options: LogOptions = {}) {
    // eslint-disable-next-line no-console
    console.error(
      'Message: %O\nTags: %O\nContext: %O\n',
      { message },
      options.tags,
      options.context,
    );
  }

  /**
   * Логирует сообщение об ошибке типа "warning"
   *
   * @param message - Сообщение об ошибке.
   * @param options - Опции, определяют что будет залогировано.
   */
  warning(message: unknown, options: LogOptions = {}) {
    // eslint-disable-next-line no-console
    console.warn(
      'Message: %O\nTags: %O\nContext: %O\n',
      { message },
      options.tags,
      options.context,
    );
  }
}
